import {
	DESCRIPTION_MAX_LENGTH,
	NAME_MAX_LENGTH,
} from 'constants/validationConstants'
import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'

import { urlSchema } from '../fieldSchemas'

export const getVideoInfoFormSchema = (t: TTranslationFunction) =>
	yup
		.object({
			title: yup
				.string()
				.notRequired()
				.max(
					NAME_MAX_LENGTH,
					t('ui__field_validation_errors__generic__max_length', {
						length: NAME_MAX_LENGTH,
					}),
				),
			description: yup
				.string()
				.notRequired()
				.max(
					DESCRIPTION_MAX_LENGTH,
					t('ui__field_validation_errors__generic__max_length', {
						length: DESCRIPTION_MAX_LENGTH,
					}),
				),
			buttons: yup
				.array(
					yup.object({
						title: yup
							.string()
							.required(t('ui__field_validation_errors__generic__required'))
							.max(
								NAME_MAX_LENGTH,
								t('ui__field_validation_errors__generic__max_length', {
									length: NAME_MAX_LENGTH,
								}),
							),
						url: urlSchema(t, { required: true }),
					}),
				)
				.required(),
		})
		.required()

export type TVideoInfoFields = InferType<
	ReturnType<typeof getVideoInfoFormSchema>
>

export type TVideoButton = TVideoInfoFields['buttons'][number]
